export default {
  contingencies: []
};
